const FAMILY_ANNUAL_EXPENSE_KEYS = [
  "personal_expenses_saving",
  "personal_expenses_tax",
  "personal_expenses_life_fund",
  "personal_expenses_social_insurance",
  "personal_expenses_consumption",
  "personal_expenses_food",
  "personal_expenses_entertainment",
  "personal_expenses_travel",
  "personal_expenses_debt",
];

// รับเฉพาะยอดรายปีชนิด number ที่เป็น finite ตามรูปแบบที่ Balance writer เก็บ ส่วนค่าผิดรูปแบบให้มีผลเป็นศูนย์เฉพาะแถวนั้น
const normalizeAnnualBalanceExpense = (value) => {
  return typeof value === "number" && Number.isFinite(value) ? value : 0;
};

// อ่านค่าอาหารรายปีจากรายการ Balance เพียงรอบเดียว และใช้ผลนี้ทับค่า derived เดิมในข้อมูลประกัน
export const mapFamilyExpensesFromBalance = (insuranceData, balanceData) => {
  const personal_expenses_food = (
    balanceData?.expenses_variable_list || []
  ).reduce((total, row) => {
    if (row?.options_expenses_variable !== "expenses_food") {
      return total;
    }
    return total + normalizeAnnualBalanceExpense(row?.pay_peryear);
  }, 0);

  return {
    ...insuranceData,
    personal_expenses_food,
  };
};

// รวมรายจ่ายครอบครัวรายปีจากแต่ละหมวด โดยค่าอาหารที่ mapper ใส่ไว้ถูกนับเพียงหนึ่งหมวด
export const calculateFamilyAnnualExpense = (insuranceData) => {
  return FAMILY_ANNUAL_EXPENSE_KEYS.reduce(
    (total, key) => total + Number(insuranceData?.[key] || 0),
    0
  );
};

// คำนวณค่าใช้จ่ายครอบครัวและมูลค่าปัจจุบันจากค่าที่แก้ล่าสุดใน event เดียวกัน เพื่อไม่ให้ผลทุนประกันอ้างยอดจาก state รอบก่อน
export const calculateFamilyProtectionBase = ({
  insuranceData,
  balanceData,
  sumIncome,
  rateDifference,
  familyYearSurvive,
  calculatePresentValue,
}) => {
  const sumPersonalExpenses = calculateFamilyAnnualExpense(insuranceData);
  const personalExpensesSaving = Number(
    insuranceData?.personal_expenses_saving || 0
  );
  let sumFamilyExpenses = 0;

  if (sumIncome === 0 || sumIncome < sumPersonalExpenses) {
    sumFamilyExpenses =
      balanceData?.sum_expenses_fixed +
      balanceData?.sum_expenses_variable -
      sumPersonalExpenses +
      personalExpensesSaving;
  } else {
    sumFamilyExpenses =
      sumIncome - sumPersonalExpenses - personalExpensesSaving;
  }

  return {
    sumPersonalExpenses,
    sumFamilyExpenses,
    sumFamily: calculatePresentValue(
      rateDifference / 100,
      familyYearSurvive,
      sumFamilyExpenses
    ),
  };
};
